import { ConnectComponent2 } from "util";
import View from "./view";
import Presenter from "./presenter";

export default ConnectComponent2(View, Presenter);



// WEBPACK FOOTER //
// ./src/components/app/registration/optional-groups/list/data-table/index.js